import React from "react";
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, ReferenceLine,
} from "recharts";
import moment from "moment";

//06 Jan 2026
import { buildActionTimeSeries } from "@/utils/performance/buildActionTimeSeries"

const EtUserActionPerformanceSelfChart = ({ action }) => {

    // First Created - 29 Sep 2025
    // Author  - Atul Pandey
    // Purpose - Show self action performance as actual vs target chart
    // Updated - 06 Jan 2025 - switched to buildActionTimeSeries utility for the performance data
  
    // Step 0 - Validate incoming data
    // console.log('ation performance self:', action)
    if (!action) return null;

    // const isRecurring = !!action?.actionRecurrencePattern;
    const isRecurring = action?.actionRecurrencePattern !== "OneTime";
    const targetValue = action?.targetValue || 0;
    let cumulative = 0;

    // Step 1 -  Transform Data
    // let performanceData = [];

    const series = buildActionTimeSeries(action, {
    granularity: "day",
    });

    const performanceData = series.map((p) => ({
    date: moment(p.dateKey).format("DD MMM"),
    actualValue: p.cumulativeActualValue,
    }));

    // 06 Jan 2026 - Prior Inline code - DO NOT DELETE - Kept for reference
    // if (isRecurring) {
    //     // Recurring → Use recurringActionLog[]
    //     const logs = (action.recurringActionLog || []).filter(log => log?.actualValue !== undefined);
    //     const sorted = logs.sort((a, b) => new Date(a.logDate) - new Date(b.logDate));

    //     performanceData = sorted.map(log => {
    //     cumulative += log.actualValue;
    //     return {
    //         date: moment(log.logDate).format("DD MMM"),
    //         actualValue: cumulative,
    //     };
    //     });
    // } else {

    //     // ✅ OneTime: each note already represents total actualValue (no accumulation)
    //     const notes = (action.userActionNotes || []).filter(note => note?.actionNoteActualValue !== undefined);
    //     const sorted = notes.sort((a, b) => new Date(a.actionNoteDate) - new Date(b.actionNoteDate));

    //     performanceData = sorted.map(note => ({
    //         date: moment(note.actionNoteDate).format("DD MMM HH:mm"),
    //         actualValue: note.actionNoteActualValue, // direct (no cumulative)
    //     }));

    //     // console.log('performance data "OneTime" ', performanceData)
    // }

    // Step 2 -  Guard - No data case
    if (!performanceData.length) {
        return (
        <div className="text-sm text-gray-500 italic mt-2">
            No performance data available yet.
        </div>
        );
    }

    // Step 3 -  Render Chart
    return (
        <div className="w-full h-64 mt-4">
        <ResponsiveContainer>
            <LineChart data={performanceData} margin={{ top: 20, right: 30, bottom: 20, left: 10 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" fontSize={12} />
            <YAxis domain={[0, Math.max(targetValue, ...performanceData.map(d => d.actualValue))]} />
            <Tooltip />
            <ReferenceLine y={targetValue} stroke="orange" strokeDasharray="5 5" label="Target" />
            <Line
                type="monotone"
                dataKey="actualValue"
                stroke="#4F46E5"
                strokeWidth={2}
                dot={{ r: 4 }}
                activeDot={{ r: 6 }}
            />
            </LineChart>
        </ResponsiveContainer>
        </div>
    );
};

export default EtUserActionPerformanceSelfChart;